import React, {memo, useState, useMemo, useEffect} from "../../../../../__snowpack__/pkg/react.js";
import {Button, Popover, Input, Select} from "../../../../../__snowpack__/pkg/antd.js";
import TagsInput from "../TagsInput.js";
import SVG from "../../../../../__snowpack__/pkg/react-inlinesvg.js";
import multipleSearch from "../../../../assets/multipleSearch.svg";
import styles from "./index.module.css";
import {useIntl} from "../../../../../__snowpack__/pkg/react-intl.js";
const Option = Select.Option;
export var SearchType;
(function(SearchType2) {
  SearchType2["LIKE"] = "LIKE";
  SearchType2["EQUALS"] = "EQUALS";
  SearchType2["SUFFIX_FUZZY"] = "SUFFIX_FUZZY";
})(SearchType || (SearchType = {}));
const BatchFilterPicker = memo((props) => {
  const {formatMessage} = useIntl();
  const {
    onChange,
    value,
    maxTagCount = 5,
    maxTagTextLength = 15,
    maxRowLength = 500,
    onlyLike = false,
    onlyEquals = false,
    type = "",
    onlyInput = false,
    level = "",
    selectStyle = {}
  } = props;
  const [open, setOpen] = useState(false);
  const handelValueChange = (targetValue) => {
    const newValue = Object.assign({}, value, targetValue);
    onChange && onChange(newValue);
  };
  const searchType = useMemo(() => {
    return value?.searchType ?? SearchType.LIKE;
  }, [value]);
  useEffect(() => {
    if (onlyLike) {
      handelValueChange({
        searchValue: [],
        searchType: SearchType.LIKE
      });
    }
    if (onlyEquals) {
      handelValueChange({
        searchValue: [],
        searchType: SearchType.EQUALS
      });
    }
  }, [onlyLike, onlyEquals]);
  return /* @__PURE__ */ React.createElement(Input.Group, {
    compact: true
  }, /* @__PURE__ */ React.createElement("div", {
    className: styles.batchFilterContent
  }, searchType !== SearchType.EQUALS || onlyInput ? /* @__PURE__ */ React.createElement(Input, {
    className: styles.batchFilterInput,
    style: {
      ...props?.inputStyle
    },
    onKeyDown: (event) => {
      if (event.key === "Enter") {
        props.search && props.search();
      }
    },
    allowClear: true,
    placeholder: onlyInput ? "" : formatMessage({id: "fuzzyOnlySupportsSingle"}),
    value: value?.searchValue,
    onChange: (event) => {
      const value2 = event?.target?.value ? [event.target.value] : [];
      if (value2.length === 0) {
        handelValueChange({
          searchValue: ""
        });
      } else {
        handelValueChange({
          searchValue: value2
        });
      }
    }
  }) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(TagsInput, {
    maxTagCount,
    maxTagTextLength,
    allowClear: true,
    onChange: (value2) => {
      handelValueChange({
        searchValue: value2
      });
    },
    value: value.searchValue,
    style: {width: "300px", ...props?.inputStyle}
  }), /* @__PURE__ */ React.createElement(Popover, {
    placement: "bottomRight",
    overlayClassName: styles.popoverContent,
    content: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Input.TextArea, {
      autoSize: {minRows: 8, maxRows: 8},
      rows: 9,
      value: value.searchValue.join?.("\n"),
      onChange: (event) => {
        const value2 = event?.target?.value?.split?.("\n");
        handelValueChange({
          searchValue: value2
        });
      },
      placeholder: formatMessage({id: "whenSearchingAccuratelyTheMaximumNumber"}, {X: maxRowLength})
    }), /* @__PURE__ */ React.createElement("div", {
      className: styles.popoverBottom
    }, /* @__PURE__ */ React.createElement(Button, {
      className: styles.cancelBtn,
      onClick: () => setOpen(false)
    }, formatMessage({id: "Cancel"})), /* @__PURE__ */ React.createElement(Button, {
      type: "primary",
      onClick: () => setOpen(false)
    }, formatMessage({id: "ok"})))),
    trigger: "click",
    visible: open
  }, /* @__PURE__ */ React.createElement(Button, {
    onClick: () => {
      setOpen(true);
    },
    className: styles.batchFilterBtn,
    icon: /* @__PURE__ */ React.createElement(SVG, {
      src: multipleSearch,
      style: {verticalAlign: "-3px"},
      fill: "#ADBACC"
    })
  })))), /* @__PURE__ */ React.createElement(Select, {
    style: {width: "155px", ...selectStyle},
    defaultValue: SearchType.LIKE,
    value: value?.searchType,
    onChange: (value2) => {
      handelValueChange({
        searchValue: value2 !== SearchType.EQUALS ? "" : [],
        searchType: value2
      });
    }
  }, level === SearchType.LIKE ? /* @__PURE__ */ React.createElement(React.Fragment, null, !onlyLike && /* @__PURE__ */ React.createElement(Option, {
    value: SearchType.EQUALS
  }, formatMessage({id: "preciseSearch"})), !onlyEquals && /* @__PURE__ */ React.createElement(Option, {
    value: SearchType.LIKE
  }, formatMessage({id: "fuzzySearch"}))) : /* @__PURE__ */ React.createElement(React.Fragment, null, !onlyEquals && /* @__PURE__ */ React.createElement(Option, {
    value: SearchType.LIKE
  }, formatMessage({id: "fuzzySearch"})), !onlyLike && /* @__PURE__ */ React.createElement(Option, {
    value: SearchType.EQUALS
  }, formatMessage({id: "preciseSearch"}))), type === SearchType.SUFFIX_FUZZY && /* @__PURE__ */ React.createElement(Option, {
    value: SearchType.SUFFIX_FUZZY
  }, formatMessage({id: "prefixSearch"}))));
});
export default BatchFilterPicker;
